module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal",
    class: {
      'd-timetal--read-only': _vm.isReadOnly
    }
  }, [_c('div', {
    staticClass: "d-timetal__container"
  }, [_c('h4', {
    staticClass: "uppercase"
  }, [_vm._v("Undervisning i specialklasser")]), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
    return _c('th', {
      key: grade.value
    }, [_vm._v(_vm._s(grade.title))])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fagMedVProps), function(fag) {
    return (!_vm.isReadOnly) ? _c('tr', {
      key: fag.fagkode
    }, [_c('td', [_vm._v(_vm._s(fag.title))]), _vm._v(" "), _vm._l((fag.klasser), function(klasse) {
      return _c('td', {
        class: [{
          'td-is-obligatorisk': klasse.v_obligatorisk
        }, {
          'td-is-checkbox': klasse.hasOwnProperty('checkbox')
        }]
      }, [(klasse.hasOwnProperty('num')) ? _c('input', {
        staticClass: "d-input",
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": klasse.num
        },
        on: {
          "blur": function($event) {
            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'konfirmation') ? _c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': fag.v_fag.klassetrin * 1 === klasse.value * 1
        },
        on: {
          "click": function($event) {
            return _vm.setKonfirmation(fag.v_fag, klasse.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'praktik') ? _c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': fag.praktikkode === 'J'
        },
        on: {
          "click": function($event) {
            return _vm.setPraktik(fag)
          }
        }
      }) : _vm._e()])
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('tr', {
    staticClass: "d-summarized"
  }, [_c('td', [_vm._v("Obligatorisk fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.obligatoriskFagopdelt), function(timer) {
    return _c('td', [_vm._v(_vm._s(timer))])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "d-summarized d-explainer"
  }, [_c('td', [_vm._v("Minimumstimetal")]), _vm._v(" "), _vm._l((_vm.minimumFagopdelt), function(num, key) {
    return _c('td', [_vm._v("(" + _vm._s(num) + ")")])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "d-summarized"
  }, [_c('td', [_vm._v("Øvrig fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.ovrigFagopdelt), function(timer) {
    return _c('td', [_vm._v(_vm._s(timer))])
  })], 2), _vm._v(" "), _vm._l((_vm.uuv), function(uuvfag) {
    return (!_vm.isReadOnly) ? _c('tr', [_c('td', [_vm._v(_vm._s(uuvfag.title))]), _vm._v(" "), _vm._l((uuvfag.klasser), function(klasse) {
      return _c('td', [(klasse.hasOwnProperty('num')) ? _c('input', {
        staticClass: "d-input",
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": klasse.num
        },
        on: {
          "blur": function($event) {
            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
          }
        }
      }) : _vm._e()])
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('tr', {
    staticClass: "d-summarized"
  }, [_c('td', [_vm._v("Skoleårets samlede længde\n          (= Obligatorisk fagopdelt undervisning\n          + øvrige fag + Understøttende undervisning)\n        ")]), _vm._v(" "), _vm._l((_vm.sammentaelling), function(timer) {
    return _c('td', [_vm._v(_vm._s(timer))])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "d-summarized d-explainer"
  }, [_c('td', [_vm._v("Mindstekrav til skoleårets samlede længde")]), _vm._v(" "), _vm._l((_vm.totalMinimum), function(num, key) {
    return _c('td', [(num > 0) ? _c('span', [_vm._v("(" + _vm._s(num) + ")")]) : _vm._e()])
  })], 2), _vm._v(" "), _vm._l((_vm.tolaererArr), function(tolaerer) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(tolaerer.title))]), _vm._v(" "), _vm._l((tolaerer.klasser), function(klasse) {
      return _c('td', {
        staticClass: "td-is-checkbox"
      }, [_c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
        },
        on: {
          "click": function($event) {
            return _vm.setTolaerer(klasse)
          }
        }
      })])
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.foranstaltningerMedProps), function(foranstaltning) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(foranstaltning.title))]), _vm._v(" "), _vm._l((foranstaltning.klasser), function(klasse) {
      return _c('td', {
        staticClass: "td-is-checkbox"
      }, [_c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
        },
        on: {
          "click": function($event) {
            return _vm.setForanstaltning(klasse)
          }
        }
      })])
    })], 2)
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e1ec158!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningTimetalFagSpecial.vue
// module id = 1909
// module chunks = 1